import { useState } from "react";
import { useAppDispatch, useAppSelector } from "src/store/hook";
import { sensothingRynanApi } from "src/services/globalAxios";
import config from "src/config";
import { rynanLogin } from "src/services/sensorthingServices";
import { Station } from "src/types/station";
import { RYNAN_STATION_GET_ALL, RYNAN_STATION_SET_SELECTED } from "src/store/station/action";

function useRynanStation() {
  const dispatch = useAppDispatch();
  const { stations, selectedStation } = useAppSelector(
    (state) => state.rynanStation
  );
  const [isLoading, setLoading] = useState(false);

  const getToken = async (): Promise<string> => {
    let token = sessionStorage.getItem("isRynanAuthentication");
    if (!token) {
      const response = await rynanLogin();
      token = response.data.token;
      sessionStorage.setItem("isRynanAuthentication", token);
    }
    return token;
  };

  const fetchStations = async () => {
    try {
      setLoading(true);
      const token = await getToken();
      const response = await sensothingRynanApi.get("/get-list-stations", {
        headers: {
          "x-access-token": token,
          "x-api-key": config.RYNAN_X_API_KEY,
        },
      });

      dispatch(
        RYNAN_STATION_GET_ALL({ stations: response.data?.data || [] })
      );
    } catch (error: any) {
      // Token hết hạn
      if (error.response?.data?.errorCode === "002") {
        sessionStorage.removeItem("isRynanAuthentication");
        await fetchStations();
      } else {
        console.error("Error fetching Rynan stations:", error);
      }
    } finally {
      setLoading(false);
    }
  };

  const selectStation = (station: Station | null) => {
    dispatch(RYNAN_STATION_SET_SELECTED({ station }));
  };

  return {
    stations,
    selectedStation,
    isLoading,
    fetchStations,
    selectStation,
  };
}

export default useRynanStation;
